import {connect} from 'react-redux';
import Form_11 from './Form_11';
import {getFileList} from '../../actions/files/getFileList';
import {uploadFile} from '../../actions/files/uploadFile';
import {setShumaStatusTypeId} from '../../actions/steps/setShumaStatusTypeId';
import {createFinalPDF} from '../../actions/steps/createFinalPDF';
import {getFile} from '../../actions/files/getFile';
import {sendForAdminApproval} from '../../actions/steps/sendForAdminApproval';
import {
  showGlobalErrorMessage
} from '../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';

const mapStateToProps = ({
                           step11FileList: {list: filesList, loading},
                           stepData: {stepData},
                           user: {userTypeID, adminPermissionsLevel},
                           shumaProperties: {shumaTypeID, propertyTypeID},
                           stepStatus: {stepStatus},
                         }) => ({
  filesList,
  loading,
  stepData,
  userTypeID,
  shumaTypeID,
  propertyTypeID,
  stepStatus,
  adminPermissionsLevel,
});

export default connect(
  mapStateToProps,
  {
    getFileList,
    uploadFile,
    setShumaStatusTypeId,
    createFinalPDF,
    getFile,
    sendForAdminApproval,
    showGlobalErrorMessage
  }
)(Form_11);
